import type { TFunction } from 'react-i18next';
import type { Folder } from 'store/automationsPage/automations.redux';

export const getFolderForFolderTree = (folder: Folder, t: TFunction) => ({
  id: folder.id,
  name: folder.name === '<business_root>' ? t('Home') : folder.name,
  parentId: folder.parent_folder_id,
  count: folder.automations_count ?? 0,
  data: folder,
});
